import React from 'react'
import { useSelector } from 'react-redux'
import objectQuery from 'loankeeper-common/containers/objectQuery'

import { getUserConfig, getSystemConfig } from '../../../store/userConfig'

export const useUserConfig = (query = '* as config') => {
  const config = useSelector(getUserConfig)

  return objectQuery(config, query)
}

export const useSystemConfig = (query = '* as config') => {
  const config = useSelector(getSystemConfig)

  return objectQuery(config, query)
}

/**
 * @param {ObjectQuery} ['* as config']
 *
 * @returns {Object}
 */
export const withUserConfig = (query) => (Component) => (props) => {
  const config = useUserConfig(query)

  return <Component {...props} {...config} />
}

/**
 * @param {ObjectQuery} ['* as config']
 *
 * @returns {Object}
 */
export const withSystemConfig = (query) => (Component) => (props) => {
  const config = useSystemConfig(query)

  return <Component {...props} {...config} />
}
